import {
    Box,
    VStack,
    Text,
    Button,
    HStack,
    Separator,
    Image,
    Drawer,
    IconButton,
    Flex,
} from "@chakra-ui/react";

import {
    useNavigate,
    useLocation,
} from "react-router-dom";

import { useDispatch } from "react-redux";

import {
    useState,
} from "react";

import routes from "../routes";

import {
    LayoutDashboard,
    Users,
    History,
    CircleHelp,
    Power,
    SettingsIcon,
    ChartBarIcon,
    Phone,
    Mail,
    Globe,
    Menu,
    Bell,
    X,
    HandHelping,
    FileText,
    ScrollText,
    HandCoins,
    Zap,
    UserPlus,
    ChevronRight,
} from "lucide-react";

import Logo from "../assets/logo.png";

import {
    logoutAction,
} from "../state/actions/authActions";


const Sidebar = ({
    onRegisterDriver,
    onDriverAffidavit,
}) => {
    const dispatch =
        useDispatch();

    const navigate =
        useNavigate();

    const location =
        useLocation();

    const [
        open,
        setOpen,
    ] = useState(false);

    const [
        quickAccessOpen,
        setQuickAccessOpen,
    ] = useState(false);


    const isActive = (
        path
    ) =>
        location.pathname === path;


    const handleLogout = () => {
        dispatch(
            logoutAction()
        );

        navigate(
            routes.login,
            {
                replace: true,
            }
        );
    };


    const handleRegisterDriver =
        () => {
            setQuickAccessOpen(false);

            onRegisterDriver?.();
        };


    const handleDriverAffidavit =
        () => {
            setQuickAccessOpen(false);

            onDriverAffidavit?.();
        };


    const menuItems = [
        {
            label: "Dashboard",
            icon: LayoutDashboard,
            path: routes.dashboard,
        },
        {
            label: "My Recruits",
            icon: Users,
            path: routes.recruits,
        },
        {
            label: "Commission History",
            icon: History,
            path: routes.commissions,
        },
        {
            label: "Notifications",
            icon: Bell,
            path: routes.notifications,
        },
        {
            label: "Settings",
            icon: SettingsIcon,
            path: routes.settings,
        },
        {
            label: "Analytics",
            icon: ChartBarIcon,
            path: routes.analytics,
        },
    ];


    const mobileNavItems = [
        {
            label: "Home",
            icon: LayoutDashboard,
            path: routes.dashboard,
        },
        {
            label: "Recruits",
            icon: Users,
            path: routes.recruits,
        },
        {
            label: "Commissions",
            icon: HandCoins,
            path: routes.commissions,
        },
        // {
        //     label: "Quick",
        //     icon: Zap,
        //     action: "quick",
        // },
        {
            label: "Settings",
            icon: SettingsIcon,
            path: routes.settings,
        },
        {
            label: "Logout",
            icon: Power,
            action: "logout",
        },
    ];


    const SidebarContent =
        () => (
            <>
                {/* LOGO */}
                <HStack
                    w="100%"
                    justify="space-between"
                    align="center"
                    mb={1}
                >
                    <HStack flex="1">
                        <Image
                            src={Logo}
                            h="32px"
                            w="32px"
                            objectFit="contain"
                        />

                        <Text
                            fontSize="16px"
                            fontWeight="700"
                            color="#2453FF"
                            whiteSpace="nowrap"
                        >
                            Mogoma Partner
                        </Text>
                    </HStack>

                    <IconButton
                        display={{
                            base: "flex",
                            md: "none",
                        }}
                        variant="ghost"
                        size="sm"
                        onClick={() =>
                            setOpen(false)
                        }
                        aria-label="Close sidebar"
                        flexShrink={0}
                    >
                        <X size={22} />
                    </IconButton>
                </HStack>


                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={8}
                    ml="40px"
                >
                    Recruit. Earn. Grow.
                </Text>


                {/* MAIN MENU */}
                <VStack
                    align="stretch"
                    gap={2}
                >
                    {menuItems.map(
                        item => {
                            const Icon =
                                item.icon;

                            const active =
                                isActive(
                                    item.path
                                );

                            return (
                                <Button
                                    key={
                                        item.label
                                    }
                                    justifyContent="flex-start"
                                    h="52px"
                                    borderRadius="10px"
                                    fontWeight="400"
                                    onClick={() => {
                                        navigate(
                                            item.path
                                        );

                                        setOpen(
                                            false
                                        );
                                    }}
                                    bg={
                                        active
                                            ? "#2453FF"
                                            : "transparent"
                                    }
                                    color={
                                        active
                                            ? "white"
                                            : "#4B5563"
                                    }
                                    _hover={{
                                        bg: active
                                            ? "#2453FF"
                                            : "#EEF3FF",
                                        color: active
                                            ? "white"
                                            : "#2453FF",
                                    }}
                                >
                                    <Icon
                                        size={
                                            18
                                        }
                                    />

                                    <Text
                                        ml={3}
                                    >
                                        {
                                            item.label
                                        }
                                    </Text>
                                </Button>
                            );
                        }
                    )}
                </VStack>


                <Separator
                    my={5}
                />


                {/* SUPPORT */}
                <VStack
                    align="stretch"
                    gap={2}
                >
                    <Button
                        variant="ghost"
                        justifyContent="flex-start"
                        h="40px"
                        onClick={() => {
                            navigate(
                                "/support"
                            );

                            setOpen(
                                false
                            );
                        }}
                    >
                        <HandHelping
                            size={18}
                        />

                        <Text
                            ml={3}
                            fontWeight="400"
                        >
                            Support
                        </Text>
                    </Button>


                    <Button
                        variant="ghost"
                        justifyContent="flex-start"
                        h="40px"
                        onClick={() => {
                            navigate(
                                "/help-topics"
                            );

                            setOpen(
                                false
                            );
                        }}
                    >
                        <FileText
                            size={18}
                        />

                        <Text
                            ml={3}
                            fontWeight="400"
                        >
                            Help Topics
                        </Text>
                    </Button>


                    <Button
                        variant="ghost"
                        justifyContent="flex-start"
                        h="40px"
                        onClick={() => {
                            navigate(
                                "/faq"
                            );

                            setOpen(
                                false
                            );
                        }}
                    >
                        <CircleHelp
                            size={18}
                        />

                        <Text
                            ml={3}
                            fontWeight="400"
                        >
                            FAQs
                        </Text>
                    </Button>


                    <Button
                        variant="ghost"
                        justifyContent="flex-start"
                        h="40px"
                        onClick={() => {
                            navigate(
                                "/terms-and-policies"
                            );

                            setOpen(
                                false
                            );
                        }}
                    >
                        <ScrollText
                            size={18}
                        />

                        <Text
                            ml={3}
                            fontWeight="400"
                        >
                            Terms & Policies
                        </Text>
                    </Button>


                    {/* CONTACT SUPPORT */}
                    <Box
                        p={4}
                        borderRadius="14px"
                        bg="white"
                        border="1px solid"
                        borderColor="gray.200"
                        mb={20}
                    >
                        <Text
                            fontSize="11px"
                            fontWeight="700"
                            color="gray.500"
                            letterSpacing="1px"
                            textTransform="uppercase"
                            mb={3}
                        >
                            Contact Support
                        </Text>

                        <VStack
                            align="start"
                            gap={3}
                        >
                            <HStack
                                color="gray.600"
                                fontSize="sm"
                            >
                                <Phone
                                    size={14}
                                    color="#2453FF"
                                />

                                <Text>
                                    +267 7601 9336
                                </Text>
                            </HStack>


                            <HStack
                                color="gray.600"
                                fontSize="sm"
                            >
                                <Mail
                                    size={14}
                                    color="#2453FF"
                                />

                                <Text>
                                    mogoma@aigenix.co.bw
                                </Text>
                            </HStack>


                            <HStack
                                color="gray.600"
                                fontSize="sm"
                                align="start"
                            >
                                <Globe
                                    size={14}
                                    color="#2453FF"
                                />

                                <Text
                                    wordBreak="break-word"
                                >
                                    aigenix.co.bw/mogoma
                                </Text>
                            </HStack>
                        </VStack>
                    </Box>
                </VStack>


                {/* LOGOUT */}
                <Box
                    mt="auto"
                    position="sticky"
                    bottom="0"
                    borderRadius="12px"
                    bg="#F4F7FC"
                    py={{
                        base: 1,
                        md: 2,
                    }}
                    px={{
                        base: 3,
                        md: 0,
                    }}
                >
                    <Button
                        variant="ghost"
                        justifyContent="center"
                        h="40px"
                        color="red.500"
                        w="100%"
                        onClick={
                            handleLogout
                        }
                        _hover={{
                            bg: "#FEE2E2",
                        }}
                    >
                        <Power
                            size={18}
                        />

                        <Text
                            ml={3}
                            fontWeight="600"
                            fontSize="16px"
                        >
                            Logout
                        </Text>
                    </Button>
                </Box>
            </>
        );


    return (
        <>
            {/* MOBILE HEADER */}
            <Box
                display={{
                    base: "flex",
                    md: "none",
                }}
                alignItems="center"
                px={4}
                py={3}
                bg="white"
                borderBottom="1px solid"
                borderColor="gray.200"
            >
                <IconButton
                    variant="ghost"
                    mr={3}
                    ml={-2}
                    cursor="pointer"
                    color="gray.600"
                    _hover={{
                        color: "#2453FF",
                    }}
                    onClick={() =>
                        setOpen(true)
                    }
                    aria-label="Open menu"
                >
                    <Menu
                        size={25}
                    />
                </IconButton>


                <HStack>
                    <Image
                        src={Logo}
                        h="30px"
                    />

                    <Text
                        fontWeight="700"
                        color="#2453FF"
                    >
                        Mogoma
                    </Text>
                </HStack>
            </Box>


            {/* DESKTOP SIDEBAR */}
            <Box
                display={{
                    base: "none",
                    md: "flex",
                }}
                bg="#F4F7FC"
                borderRight="1px solid"
                borderColor="gray.200"
                p={6}
                h="100vh"
                overflowY="auto"
                flexDirection="column"
            >
                <SidebarContent />
            </Box>


            {/* MOBILE SIDEBAR DRAWER */}
            <Drawer.Root
                open={open}
                placement="start"
                onOpenChange={e =>
                    setOpen(
                        e.open
                    )
                }
            >
                <Drawer.Backdrop />

                <Drawer.Positioner>
                    <Drawer.Content
                        maxW="280px"
                        h="100dvh"
                    >
                        <Drawer.Body p={6}>
                            <Box
                                display="flex"
                                flexDirection="column"
                                h="100%"
                            >
                                <SidebarContent />
                            </Box>
                        </Drawer.Body>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Drawer.Root>


            {/* QUICK ACCESS DRAWER */}
<Drawer.Root
    open={quickAccessOpen}
    placement="bottom"
    onOpenChange={(e) =>
        setQuickAccessOpen(e.open)
    }
>
    <Drawer.Backdrop />

    <Drawer.Positioner>
        <Drawer.Content
            borderTopLeftRadius="24px"
            borderTopRightRadius="24px"
            bg="white"
            minH="350px"
            maxH="70dvh"
            pb="env(safe-area-inset-bottom)"
            overflow="hidden"
        >
            {/* SWIPE HANDLE */}
            <Flex
                justify="center"
                pt={3}
                pb={1}
                cursor="grab"
            >
                <Box
                    w="42px"
                    h="5px"
                    borderRadius="full"
                    bg="gray.300"
                />
            </Flex>

            {/* HEADER */}
            <Drawer.Header
                px={5}
                pt={3}
                pb={3}
            >
                <Flex
                    w="100%"
                    align="center"
                    justify="space-between"
                >
                    <HStack gap={2}>
                        <Zap
                            size={19}
                            color="#2453FF"
                        />

                        <Text
                            fontSize="18px"
                            fontWeight="700"
                            color="#071D54"
                        >
                            Quick Access
                        </Text>
                    </HStack>

                    {/* CLOSE BUTTON AT THE END */}
                    <IconButton
                        variant="ghost"
                        size="sm"
                        onClick={() =>
                            setQuickAccessOpen(
                                false
                            )
                        }
                        aria-label="Close quick access"
                        borderRadius="full"
                        color="gray.500"
                        _hover={{
                            bg: "gray.100",
                            color: "#071D54",
                        }}
                    >
                        <X size={20} />
                    </IconButton>
                </Flex>
            </Drawer.Header>

            {/* CONTENT */}
            <Drawer.Body
                px={5}
                pt={2}
                pb={8}
                overflowY="auto"
            >
                <VStack
                    align="stretch"
                    gap={3}
                >
                    {/* REGISTER DRIVER */}
                    <Button
                        w="100%"
                        minH="68px"
                        h="68px"
                        justifyContent="space-between"
                        px={4}
                        bg="#F8FAFC"
                        border="1px solid"
                        borderColor="gray.200"
                        borderLeft="3px solid"
                        borderLeftColor="#2453FF"
                        borderRadius="12px"
                        color="#071D54"
                        flexShrink={0}
                        onClick={
                            handleRegisterDriver
                        }
                        _hover={{
                            bg: "#EEF3FF",
                            borderColor:
                                "#2453FF",
                        }}
                        _active={{
                            bg: "#EEF3FF",
                        }}
                    >
                        <HStack gap={3}>
                            <Flex
                                w="44px"
                                h="44px"
                                borderRadius="10px"
                                bg="#EEF3FF"
                                align="center"
                                justify="center"
                                flexShrink={0}
                            >
                                <UserPlus
                                    size={21}
                                    color="#2453FF"
                                />
                            </Flex>

                            <Text
                                fontWeight="600"
                                fontSize="15px"
                            >
                                Register Driver
                            </Text>
                        </HStack>

                        <ChevronRight
                            size={20}
                            color="#2453FF"
                        />
                    </Button>

                    {/* DRIVER AFFIDAVIT */}
                    <Button
                        w="100%"
                        minH="68px"
                        h="68px"
                        justifyContent="space-between"
                        px={4}
                        bg="#F8FAFC"
                        border="1px solid"
                        borderColor="gray.200"
                        borderLeft="3px solid"
                        borderLeftColor="#2453FF"
                        borderRadius="12px"
                        color="#071D54"
                        flexShrink={0}
                        onClick={
                            handleDriverAffidavit
                        }
                        _hover={{
                            bg: "#EEF3FF",
                            borderColor:
                                "#2453FF",
                        }}
                        _active={{
                            bg: "#EEF3FF",
                        }}
                    >
                        <HStack gap={3}>
                            <Flex
                                w="44px"
                                h="44px"
                                borderRadius="10px"
                                bg="#EEF3FF"
                                align="center"
                                justify="center"
                                flexShrink={0}
                            >
                                <FileText
                                    size={21}
                                    color="#2453FF"
                                />
                            </Flex>

                            <Text
                                fontWeight="600"
                                fontSize="15px"
                            >
                                Driver Affidavit
                            </Text>
                        </HStack>

                        <ChevronRight
                            size={20}
                            color="#2453FF"
                        />
                    </Button>
                </VStack>
            </Drawer.Body>
        </Drawer.Content>
    </Drawer.Positioner>
</Drawer.Root>

            {/* MOBILE BOTTOM NAV */}
            <Box
                display={{
                    base: "flex",
                    md: "none",
                }}
                position="fixed"
                bottom="0"
                left="0"
                right="0"
                h="72px"
                bg="white"
                borderTop="1px solid"
                borderColor="gray.200"
                borderTopLeftRadius="20px"
                borderTopRightRadius="20px"
                boxShadow="0 -4px 18px rgba(0,0,0,.08)"
                justifyContent="space-around"
                alignItems="center"
                zIndex="2000"
            >
                {mobileNavItems.map(
                    item => {
                        const Icon =
                            item.icon;

                        const active =
                            item.path &&
                            isActive(
                                item.path
                            );

                        const isQuick =
                            item.action ===
                            "quick";

                        const isLogout =
                            item.action ===
                            "logout";

                        return (
                            <VStack
                                key={
                                    item.label
                                }
                                gap={1}
                                cursor="pointer"
                                flex={1}
                                h="100%"
                                justify="center"
                                onClick={() => {
                                    if (
                                        isQuick
                                    ) {
                                        setQuickAccessOpen(
                                            true
                                        );

                                        return;
                                    }

                                    if (
                                        isLogout
                                    ) {
                                        handleLogout();

                                        return;
                                    }

                                    navigate(
                                        item.path
                                    );
                                }}
                            >
                                <Icon
                                    size={22}
                                    color={
                                        active
                                            ? "#2453FF"
                                            : isLogout
                                            ? "#EF4444"
                                            : "#8B95A7"
                                    }
                                    strokeWidth={
                                        active
                                            ? 2.6
                                            : 2
                                    }
                                />

                                <Text
                                    fontSize="10px"
                                    fontWeight={
                                        active
                                            ? "700"
                                            : "500"
                                    }
                                    color={
                                        active
                                            ? "#2453FF"
                                            : isLogout
                                            ? "#EF4444"
                                            : "gray.500"
                                    }
                                >
                                    {
                                        item.label
                                    }
                                </Text>
                            </VStack>
                        );
                    }
                )}
            </Box>
        </>
    );
};


export default Sidebar;